<template>
  <div
    class="flex flex-col bg-muted-card rounded-md font-text text-n-0 cursor-pointer hover:scale-110 transition-transform w-32"
    :class="{
      'opacity-50':
        !isAttendanceMode && ((!shiftStarted && !canStartShift(employee)) || !isCheckedIn(employee))
    }"
    @click="isAttendanceMode ? (clockingEmployee = employee) : safeSelectEmployee(employee)"
  >
    <div class="mt-6 mb-4">
      <div
        class="uppercase mx-auto text-3xl font-bold w-14 h-14 flex items-center justify-center rounded-full"
        :class="[getColorClass(employee.position)]"
      >
        {{ shortName(employee.name) }}
      </div>
    </div>
    <div class="flex-1 mb-4 text-center px-2 line-clamp-2">
      {{ employee.name }}
    </div>
    <div
      v-if="isAttendanceMode && (employee.clockIn || employee.clockOut)"
      class="items-end w-full px-2 text-center text-n-300 text-xs mb-2"
    >
      {{
        hasClockedIn(employee)
          ? t('employees.attendance.clocked-in')
          : t('employees.attendance.clocked-out')
      }}
      <div class="flex items-center justify-center gap-1">
        {{ formatClockInTime(hasClockedIn(employee) ? employee.clockIn! : employee.clockOut!) }}
        <div
          class="rounded-full w-2 h-2"
          :class="[hasClockedIn(employee) ? 'bg-g-500' : 'bg-n-300']"
        ></div>
      </div>
    </div>
    <div class="items-end w-full px-2" v-else>
      <div class="radius-6 w-full h-1 mb-2" :class="[getColorClass(employee.position)]" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'

import { useEmployeeStore } from '@/store/employee'
import type { Employee } from '@/types'

type Props = {
  employee: Employee
}
defineProps<Props>()

const { t } = useI18n()

const employeeStore = useEmployeeStore()
const {
  getColorClass,
  shortName,
  canStartShift,
  isCheckedIn,
  safeSelectEmployee,
  formatClockInTime,
  hasClockedIn
} = employeeStore
const { isAttendanceMode, clockingEmployee, shiftStarted } = storeToRefs(employeeStore)
</script>
